import { render, staticRenderFns } from "./ModalAssignCompany.vue?vue&type=template&id=85cd1e16"
import script from "./ModalAssignCompany.vue?vue&type=script&lang=js"
export * from "./ModalAssignCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports